import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { Release } from 'src/api'
import { useApiInstance } from './useApiInstance'
import {
  buildRequestParams,
  ObjectType,
  transformPage,
  transformPerPage,
} from './helpers'

interface RequestParams {
  params?: Partial<AdminReleasesGetParams>;
  paramsTransform?: Array<(params: Record<string, any>) => Record<string, any>>;
  options?: Omit<
    UseQueryOptions<unknown, Error, Release[]>,
    'queryKey' | 'queryFn'
  >;
}

export interface AdminReleasesGetParams {
  limit: number;
  offset: number;
  sort: string;
}

const schema: ObjectType['schema'] = {
  limit: 'number',
  offset: 'number',
  sort: 'string',
}

export const useReleaseListRequest = ({
  params = {},
  paramsTransform = [],
  options,
}: RequestParams = {}) => {
  const api = useApiInstance()

  const transformedParams = [
    transformPerPage,
    transformPage,
    ...paramsTransform,
  ].reduce((param, transform) => transform(param), params)

  const queryParams = buildRequestParams<AdminReleasesGetParams>(
    transformedParams,
    schema,
  )

  return useQuery<unknown, Error, Release[]>(
    [Entities.Release, JSON.stringify(transformedParams)],
    async () => {
      const {
        limit,
        offset,
        sort,
      } = queryParams
      const { data } = await api.v1AdminReleasesGet(
        limit,
        offset,
        sort,
      )
      return data
    },
    {
      ...options,
    },
  )
}
